import { render, staticRenderFns } from "./FiltroNotasParciais.vue?vue&type=template&id=be4b1c04&"
import script from "./FiltroNotasParciais.vue?vue&type=script&lang=js&"
export * from "./FiltroNotasParciais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports